import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import Home from "../components/Homesss.js";
import TermsAndConditions from "../components/TermsAndConditions";
import PrivacyPolicy from "../components/PrivacyPolicy";
import HomeDashboard from "../components/Home.js";

const AppRoutes = () => {
  return (
    <div>
      <Router>
        <Routes>
          <Route path="/" element={<HomeDashboard />} />
          <Route path="/termsandconditions" element={<TermsAndConditions /> } />
          <Route path="/Privacypolicy" element={<PrivacyPolicy /> } />

        </Routes>
      </Router>
    </div>
  );
};

export default AppRoutes;
